import { context } from '@wikia/ad-engine';

export function getOguryContext(): object {
	const floorAdhesionConfigs = context.get('experiments.persistentAdhesionExperiment')
		? {}
		: {
				floor_adhesion: {
					sizes: context.get('experiments.oversizedAds')?.mobile?.floor_adhesion ?? [
						[300, 50],
						[320, 50],
						[320, 100],
					],
					adUnitId: '164a1270-d078-013a-6f90-0d319559df69',
					assetKey: 'OGY-311D7E535854',
				},
			};

	return {
		enabled: false,
		slots: {
			...floorAdhesionConfigs,
		},
	};
}
